import { c as _c } from "react/compiler-runtime";
import { AccessibleHiddenText } from '@cc-shopping/ui/primitives/AccessibleHiddenText';
import { Box, Divider, Skeleton, Stack } from '@mui/material';
const INPUT_MAX_WIDTH = '298px';
const SUBMIT_BUTTON_MAX_WIDTH = '240px';

/**
 * Shown by `dynamicWithRetry`'s `loading` option while the real `ActivationForm` chunk loads.
 * Matches its grid dimensions so nothing shifts when the real form pops in.
 */
export function ActivationFormSkeleton() {
  const $ = _c(9);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <AccessibleHiddenText>Loading approval odds form…</AccessibleHiddenText>;
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  let t1;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = {
      display: "contents"
    };
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = {
      xs: "1fr",
      sm: `minmax(0, ${INPUT_MAX_WIDTH}) minmax(0, ${INPUT_MAX_WIDTH}) minmax(0, ${SUBMIT_BUTTON_MAX_WIDTH})`
    };
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  let t3;
  if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = {
      display: "grid",
      gridTemplateColumns: t2,
      columnGap: 3,
      rowGap: {
        xs: 3,
        sm: 1
      },
      alignItems: "end"
    };
    $[3] = t3;
  } else {
    t3 = $[3];
  }
  let t4;
  if ($[4] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = <div><Skeleton variant="text" width="40%" sx={{
        fontSize: "0.875rem",
        mb: 0.5
      }} /><Skeleton variant="rounded" height="2.5rem" /></div>;
    $[4] = t4;
  } else {
    t4 = $[4];
  }
  let t5;
  if ($[5] === Symbol.for("react.memo_cache_sentinel")) {
    t5 = <Box sx={t3}>{t4}<div><Skeleton variant="text" width="40%" sx={{
          fontSize: "0.875rem",
          mb: 0.5
        }} /><Skeleton variant="rounded" height="2.5rem" /></div><Skeleton variant="rounded" height="2.5rem" /></Box>;
    $[5] = t5;
  } else {
    t5 = $[5];
  }
  let t6;
  if ($[6] === Symbol.for("react.memo_cache_sentinel")) {
    t6 = <Divider sx={{
      borderColor: "neutral.lighter-2",
      mt: 0.5
    }} />;
    $[6] = t6;
  } else {
    t6 = $[6];
  }
  let t7;
  if ($[7] === Symbol.for("react.memo_cache_sentinel")) {
    t7 = <Skeleton variant="text" width="100%" sx={{
      fontSize: "0.875rem"
    }} />;
    $[7] = t7;
  } else {
    t7 = $[7];
  }
  let t8;
  if ($[8] === Symbol.for("react.memo_cache_sentinel")) {
    t8 = <Stack rowGap={3} role="status">{t0}<Box aria-hidden={true} sx={t1}>{t5}{t6}<div>{t7}<Skeleton variant="text" width="100%" sx={{
            fontSize: "0.875rem"
          }} /></div></Box></Stack>;
    $[8] = t8;
  } else {
    t8 = $[8];
  }
  return t8;
}